module.exports = __webpack_public_path__ + "static/media/intro.9fd8abd6.png";